// extracted by mini-css-extract-plugin
export default {"SearchBar":"SearchBar_SearchBar__7XwIt","SearchBar__Sm":"SearchBar_SearchBar__Sm__2Pu0K"};